<template>
  <div class="help-page">
    <app-view-layout
      header="Pomoc"
    >
      <template #content>
        <v-card class="mt-4">
          <v-card-title>
            <span>Informacje</span>
            <v-btn
              v-if="isEditPermitted && !isEditMode"
              color="primary"
              @click="isEditMode = true"
            >
              Edytuj
            </v-btn>
          </v-card-title>
          <template v-if="isEditPermitted && isEditMode">
            <v-card-text>
              <quill-editor
                ref="quillEditor"
                v-model="helpUpdate"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="error"
                @click="isEditMode = false; helpUpdatedText = ''"
              >
                Anuluj
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!isTextUpdated"
                @click="updateHelp"
              >
                Zapisz
              </v-btn>
            </v-card-actions>
          </template>
          <v-card-text
            v-else
            class="help-page__text"
            v-html="sanitizedHelp"
          />
        </v-card>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

export default {
  components: {
    AppViewLayout,
    quillEditor,
  },
  data: () => ({
    isEditMode: false,
    helpUpdatedText: '',
  }),
  computed: {
    ...mapState('help', ['help']),
    ...mapGetters('auth', ['checkUserPermissions']),

    sanitizedHelp() {
      return this.$sanitize(this.help);
    },
    helpUpdate: {
      get() {
        return this.help;
      },
      set(helpText) {
        this.helpUpdatedText = helpText;
      },
    },
    isTextUpdated() {
      return !!this.helpUpdatedText && this.helpUpdatedText !== this.help;
    },
    isEditPermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
  },
  created() {
    this.getHelpText();
  },
  methods: {
    ...mapActions('help', [
      'getHelpText',
      'updateHelpText',
    ]),
    updateHelp() {
      this.updateHelpText(this.helpUpdatedText)
        .then(() => {
          this.isEditMode = false;
          this.helpUpdatedText = '';
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.help-page {
  &__text {
    color: $darken;
    margin: 16px 0 185px;
  }
}
</style>
